import classes from "./GraphRecord.module.css";
import log from "../../../../store/logo.png"
import {useState} from "react";
import { assetsBaseUrl } from "../../../../routes";

const GraphRecord = (props) => {

    const [logo, setLogo] = useState(`${assetsBaseUrl}${props.data.path}`||"")
    const [time, setTime] = useState(`${props.data.dateFrom.substring(11,16)||""} - ${props.data.dateTo.substring(11,16)||""}`)
    return <div className={classes.cont}>
        <div className={classes.logo}>
            <img src={logo}/>
        </div>
        <div className={classes.time}>{time}</div>
    </div>
}
export default GraphRecord;